import { IColumn, ICalculatedColumn, FixedDirection, TextAlign, IStyle, TheadRowItem, FlatColumnsFirstLevel } from './interface';
import { classSet } from '@umu/umu-dom';

export const getInitWidth = (columns: IColumn[]) => {
    let w = 0;
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        if (/^[0-9]+$/.test(String(column.width))) {
            w += Number(column.width);
        } else {
            return null;
        }
    }
    return w;
};

export const getItemClassName = (column: IColumn, index: number, lastFixedLeft: number, firstFixedRight: number) => {
    return classSet({
        [column.className || '']: true,
        'fixed-left': column.fixed === FixedDirection.left,
        'fixed-right': column.fixed === FixedDirection.right,
        'last-fixed-left': index === lastFixedLeft,
        'first-fixed-right': index === firstFixedRight,
        'align-right': column.textAlign === TextAlign.right,
        'align-center': column.textAlign === TextAlign.center,
    });
};

export const getItemStyle = (column: ICalculatedColumn, multiplier?: number) => {
    const style: IStyle = {};
    if (column.width) {
        style.width = (multiplier ? Number(column.width) * multiplier : column.width) + 'px';
    }
    if (column.fixed) {
        style[column.fixed] = column.position + 'px';
    }
    return style;
};


export function parseHeaderRows(
    rootColumns: IColumn[],
): TheadRowItem[][] {
    const rows: TheadRowItem[][] = [];

    function fillRowCells(
        columns: IColumn[],
        colIndex: number,
        rowIndex: number = 0,
    ): number[] {
        rows[rowIndex] = rows[rowIndex] || [];

        let currentColIndex = colIndex;
        const colSpans: number[] = columns.filter(Boolean).map(column => {
            const cell: TheadRowItem = {
                column,
                colStart: currentColIndex,
            };

            let colSpan: number = 1;

            const subColumns = (column as IColumn).children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(
                    (total, count) => total + count,
                    0,
                );
                cell.hasSubColumns = true;
            }

            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart as number + colSpan - 1;
            rows[rowIndex].push(cell);

            currentColIndex += colSpan;

            return colSpan;
        });

        return colSpans;
    }

    fillRowCells(rootColumns, 0);
    const rowCount = rows.length;
    for (let rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
        rows[rowIndex].forEach(cell => {
            if (!('rowSpan' in cell) && !cell.hasSubColumns) {
                cell.rowSpan = rowCount - rowIndex;
            }
        });
    }
    return rows;
}


export function flatColumns(columns: IColumn[]): IColumn[] {
    return columns
        .filter(column => column && typeof column === 'object')
        .reduce((list, column) => {

            const subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                return [
                    ...list,
                    ...flatColumns(subColumns).map(subColum => ({
                        ...subColum,
                    })),
                ];
            }
            return [
                ...list,
                {
                    ...column,
                },
            ];
        }, [] as IColumn[]);
}

export function flatColumnsFirstLevel(columns: IColumn[]): FlatColumnsFirstLevel {
    return columns.reduce((prev, column) => {
        prev[column.dataIndex] = column.children ? flatColumns(column.children) : [column];
        return prev;
    }, {} as FlatColumnsFirstLevel);
}